import {Injectable} from '@angular/core';
import {SessionService, User} from './session.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {Apollo} from 'apollo-angular';
import gql from 'graphql-tag';
import {pluck} from 'rxjs/operators';
import {flatten} from 'lodash-es';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';


export interface MenuItem {
  id: number;
  link: string;
  icon: string;
  seq: number;
  subMenus: SubMenu[];
  text: string;
}

export interface SubMenu {
  id: number;
  link: string;
  seq: number;
  text: string;
  roles: string[];
  srims: boolean;
}

const MENU_GQL = `
query MyQuery($uatOnly: Boolean_comparison_exp = {}) {
  core_menus(order_by: {seq: asc}) {
    icon
    id
    seq
    link
    subMenus(order_by: {seq: asc}, where: {uatOnly: $uatOnly}) {
      id
      link
      roles
      seq
      text
      srims
    }
    text
  }
}
`;


@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menu$ = new BehaviorSubject(null);
  private flatMenus = [];

  constructor(private sess: SessionService,
              private router: Router,
              private apollo: Apollo) {
  }

  async isValidUrl(url: string): Promise<boolean> {
    if (!this.menu$.value) {
      await this.updateMenu(this.sess.user());
    }
    return this.flatMenus.some(f => url.startsWith(f) || this.sess.user().role === 'admin');
  }

  async updateMenu(user: User): Promise<void> {
    let menus;
    const condition = environment.production ? {
      'uatOnly': {
        '_eq': false
      }
    } : {};
    if (!!user.role) {
      menus = await this.apollo.query({
        query: gql(MENU_GQL), variables: condition
      }).pipe(
        pluck('data', 'core_menus')
      ).toPromise();
    } else {
      menus = [];
    }
    this.menu$.next(menus);
    const subMenus = menus.map(m => {
      return m.subMenus.map(s => {
        return `/${m.link}/${s.link}`;
      });
    });
    this.flatMenus = ['/welcome', ...flatten(subMenus)];
  }

  getMenu$(): Observable<any> {
    return this.menu$.asObservable();
  }


}
